import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GStatic } from '../../../services/GStatic';

@Component({
  selector: 'app-dialog-move-to-category',
  templateUrl: './dialog-move-to-category.component.html',
  styleUrls: ['./dialog-move-to-category.component.scss'],
})
export class DialogMoveToCategoryComponent implements OnInit {
  category_id: any;

  constructor(
    public dialogRef: MatDialogRef<DialogMoveToCategoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    setTimeout(() => {
      GStatic.log(this.data);
    }, 1000);
  }
}
